<template>
  <!-- 健康人页面 -->
  <div class="begin">
    <div class="health">
      <!-- 查询搜索功能 -->
      <div class="search">
        <van-search
          v-model="searchvalue"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
        >
          <template #action>
            <div @click="onSearch" style="font-size: 14px;">搜索</div>
          </template>
        </van-search>

      </div>
    </div>
    <div class="swipe">
      <van-swipe class="my-swipe" style="height: 150px;" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in data" :key="index">
          <img style="width: 100%;height: 100%;" v-lazy="item.image.preview_url"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 查询条件组件 -->
    <van-sticky class="sticky1">
    <div class="zhineng">
      <div class="beginzhineng">
        <div @click="getflist">智能推荐</div>
        <!-- 智能推荐组件弹窗 -->
        <van-action-sheet v-model="show1" class="citychange" title="智能推荐">
          <div class="quyu">当前距您最近的区域是</div>
          <div class="quyucontent" style="margin-bottom: 20px;">
            <div class="cityconpos">
              <div class="citycon">
                <div class="citypos" v-for="(item,index) in flist" :key="index">
                  <div :style="cityold === item.name ? 'color:#57CAC6;' : '' " @click="setCity(item.name)" >{{item.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </van-action-sheet>
        <div @click="show = true">分类选择</div>
        <van-action-sheet class="citychange" v-model="show" title="选择分类">
          <div class="quyucontent" style="padding-top: 5px;">
            <div class="cityconpos" style="margin-top: 0px;">
              <div class="citycon1" style="margin-top: 10px; margin-bottom: 20px; justify-content: flex-start;">
                <div  style="margin-right: 10px;margin-top: 10px;" @click="setfl('')" :class=" category_id === '' ? 'acbutton' : 'dfbutton' " type="primary" round>不 限</div>
                <div style="margin-right: 10px;margin-top: 10px;" @click="setfl(item.category_id)"  :key="index" v-for="(item,index) in clist"  :class=" category_id === item.category_id ? 'acbutton' : 'dfbutton' "  type="primary" round>{{item.name}}</div>
              </div>
            </div>
          </div>
        </van-action-sheet>
<!--        <div>适应症</div>-->
        <div @click="show2 = true">筛选条件</div>
        <van-action-sheet class="citychange" v-model="show2" title="筛选条件">
          <div class="quyucontent" style="padding-top: 5px;">
            <div class="cityconpos" style="margin-top: 0px;">
              <div style="text-align: left;color: #AAAAAA">价格</div>
              <div class="citycon1" style="margin-top:0px; margin-bottom: 10px; justify-content: flex-start;">
                <div style="margin-right: 10px;margin-top: 10px;" @click="setjiage('')" :class="jiage === '' ? 'acbutton' : 'dfbutton' " type="primary" round>不 限</div>
                <div style="margin-right: 10px;margin-top: 10px;" @click="setjiage(true)" :class="jiage === true ? 'acbutton' : 'dfbutton' " type="primary"  round>1万元以上</div>
                <div style="margin-right: 10px;margin-top: 10px;" @click="setjiage(false)" :class="jiage === false ? 'acbutton' : 'dfbutton' " type="primary" round>1万元以下</div>
              </div>
            </div>
            <div class="cityconpos" style="margin-top: 0px;">
              <div style="text-align: left;color: #AAAAAA">项目标签 </div>
              <div class="citycon1" style="margin-top: 0px; margin-bottom: 10px; justify-content: flex-start;">
                <div style="margin-right: 10px;margin-top: 10px;" @click="setbiaoqian('')" :class=" biaoqian === '' ? 'acbutton' : 'dfbutton' " type="primary" round>不 限</div>
                <div style="margin-right: 10px;margin-top: 10px;" :key="index" v-for="(item,index) in serviceList" @click="setbiaoqian(item)" :class=" biaoqian === item ? 'acbutton' : 'dfbutton' " type="primary" round>{{item}}</div>
              </div>
            </div>
            <div class="cityconpos" style="margin-top: 0px;margin-bottom: 20px;">
              <div style="text-align: left;color: #AAAAAA">招募条件</div>
              <div class="citycon1" style="margin-top: 0px; margin-bottom: 10px; justify-content: flex-start;">
                <div style="margin-right: 10px;margin-top: 10px;" @click="settiaojian('')" :class=" tiaojian === '' ? 'acbutton' : 'dfbutton' " type="primary"  round>不 限</div>
                <div style="margin-right: 10px;margin-top: 10px;" @click="settiaojian(10)" :class=" tiaojian === 10 ? 'acbutton' : 'dfbutton' " type="primary"  round>只招男</div>
                <div style="margin-right: 10px;margin-top: 10px;" @click="settiaojian(20)" :class=" tiaojian === 20 ? 'acbutton' : 'dfbutton' " type="primary"  round>只招女</div>
                <div style="margin-right: 10px;margin-top: 10px;" @click="settiaojian(30)" :class=" tiaojian === 30 ? 'acbutton' : 'dfbutton' " type="primary"  round>男满招女</div>
                <div style="margin-right: 10px;margin-top: 10px;" @click="settiaojian(40)" :class=" tiaojian === 40 ? 'acbutton' : 'dfbutton' " type="primary"  round>女满招男</div>
              </div>
            </div>

          </div>
          <div style="display: flex;justify-content: space-between;margin-left: 15px;margin-right: 15px;margin-bottom: 20px;">
            <van-button @click="saveSeach(true)" style="height: 35px; width: 45%;font-size: 14px;color: #fff;background-color: #57CAC6;border: 1px solid #57CAC6;" type="primary" size="large" round>确认</van-button>
            <van-button  @click="saveSeach(false)" style="height: 35px; width: 45%;font-size: 14px;background-color: #fff;color: #57CAC6;border: 1px solid #57CAC6;" plain size="large" round>取消</van-button>
          </div>
        </van-action-sheet>
      </div>
    </div>
    </van-sticky>
    <!-- 项目列表组件 -->
    <van-pull-refresh style="margin-bottom: 60px;" v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="itemcontent" @click="gotoDetials(item)" v-for="(item,index) in list" :key="index">
          <div class="itembegin">
            <div class="laber" style="height: 50px;">
              <van-tag type="primary" style="height: 18px;font-size: 12px;">{{item.category.category.name}}</van-tag>
              <span class="name" style="font-size: 14px;">{{item.goods_name}}</span>
            </div>

          </div>
          <div class="yaowu">
            <span>研究药物：{{item.goods_medicine}}</span>
          </div>
          <div class="yaowu">
            <span>适应症：{{item.goods_syz}}</span>
          </div>
          <div class="yaowu">
            <span>中心医院：{{item.goods_address_deail}}</span>
          </div>
          <div class="yaowu">
            <span style="margin-right: 5px;" v-for="(e,i) in getSpans(item.spans)" :key="i">{{e}}</span>
          </div>
          <div class="buchang" style="font-size: 14px;">
            <span>项目补助：{{ getMoney(item)}}元</span>  <span v-if="buttonName=== '我要推荐'">推荐费: 男{{item.line_price_max}}元</span>  <span v-if="buttonName=== '我要推荐'">女{{item.line_price_min}}元</span>
          </div>
          <van-divider />
          <div class="zhaomu">
            <div class="zhao" >
              <span :style="getStatusColor(item.status)">{{getStatus(item.status)}}</span>
              <span class="pp" :style="getStatusRecColorz(item.status_rec)">{{getStatusRec(item.status_rec)}}</span>
            </div>
            <div class="baoming">
              <van-button :class="item.status === 60 ? 'dests':''"  @click="gotoDetials(item)"  type="info" round size="small">{{buttonName}}</van-button>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>

  </div>
</template>
<script>
import {Toast} from 'vant'
import {
  bannerList,
  categoryList,
  getAreList,
  getAreListIsP,
  loginAuth,
  serviceAll,
  serviceAllByOrder
} from "../api/common";
import {getStatus, getStatusColor, getStatusRec, getStatusRecColorz, getTime} from "../utils/auth";
import {List} from "../api/goods";
import myBMap from '@/utils/myBMap';
import wx from "_weixin-js-sdk@1.6.0@weixin-js-sdk";

export default {
  name: 'patient',
  data() {
    return {
      loading: false,
      finished: false,
      isLoading: false,
      clist:[],
      searchvalue:'',
      category_id:'',
      show:false,
      show1:false,
      show2:false,
      serviceList:[],
      flist:[],
      value: '',
      images: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg',
      ],
      count:0,
      data: [],
      list: [],
      page:0,
      jiage:'',
      biaoqian:'',
      tiaojian:'',
      city:'',
      cityold:'',
      buttonName:"我要报名"
    };
  },
  created() {
    this.category_id = 10012
    this.city = localStorage.getItem('city')
    this.getBannerList()
    this.getcategoryList()
    this.getserviceAll();
    if(parseInt(localStorage.getItem('grade'))>1){
      this.buttonName = '我要推荐'
    }
    this.getCity();
  },
  methods: {
    getMoney(item){
      let money = "";
      if(parseInt(item.goods_price_max)>0){
        if(parseInt(item.goods_price_min)<=0){
          money= parseInt(item.goods_price_max)
        }else{
          money= money+"男"+parseInt(item.goods_price_max)
        }
      }
      if(parseInt(item.goods_price_min)>0){
        money= money+"女"+parseInt(item.goods_price_min)
      }
      if(parseInt(item.goods_price_min) === parseInt(item.goods_price_max)){
        money = parseInt(item.goods_price_max);
      }
      return money;
    },
    getSpans(spans){
      if(spans !=='' && spans !==null){
        console.log(spans.split("，"))
        return spans.split("，")
      }
      return spans
    },
    async getflist(){
      console.log(this.city)
      if(this.city === '' || this.city == null){
        Toast('请重新定位所在城市');
        await this.getCity();
        return
      }
      this.show1 = true
      this.flist = []
      let res = await getAreListIsP()
      if (res.status === 200) {
        let ic = 0
        for (let i = 0; i <  res.data.list.length; i++) {
          if(res.data.list[i]['name'] === this.city){
            ic = i
          }
        }
        for (let i = 0; i <  res.data.list.length; i++) {
          if(i < ic+6 && i> ic-6 && i !==ic){
            this.flist.push(res.data.list[i])
          }
        }
      }
    },
    async getserviceAll(){
      // let res = await serviceAll()
      // if(res.status == 200){
      //   this.serviceList = res.data.list
      // }
      let res = await serviceAllByOrder()
      if (res.status == 200) {
        this.serviceList = res.data.list
      }
    },
    async setCity(val) {
      if (val != '未知') {
        if (val == '全国') {
          this.cityold = ""
        } else {
          this.cityold = val
        }
        this.show1 = false
        await this.onRefresh()
      }
    },
    async setfl(val){
      this.category_id =  val
      await this.onRefresh()
      this.show = false
    },
    async getcategoryList(){
      let res = await categoryList()
      if(res.status == 200) {
        //赋值
        this.clist = res.data.list;
      }
    },
    async saveSeach(val){
      if(val){
        //调用
        await this.onRefresh()
      }else{
        this.jiage = ''
        this.biaoqian = ''
        this.tiaojian = ''
      }
      this.show2 = false
    },
    setjiage(val){
      this.jiage = val
    },
    setbiaoqian(val){
      this.biaoqian = val
    },
    settiaojian(val){
      this.tiaojian = val
    },
    getTime(val){
      return getTime(val)
    },
    getStatusRecColorz(val){
      return getStatusRecColorz(val)
    },
    getStatusRec(val){
      return getStatusRec(val)
    },
    getStatusColor(val){
      return getStatusColor(val)
    },
    getStatus(val){
      return getStatus(val)
    },
    async onRefresh() {
        this.page = 1
        this.list = []
        await this.getGoodsList();
        this.isLoading = false;
    },
    async onLoad() {
        this.page++;
        await this.getGoodsList();
        this.loading = false;
        if (this.list.length >= this.count) {
          this.finished = true;
        }
    },
    async getGoodsList(){
      localStorage.setItem('toph',0)
      let json = {
        page:this.page,
        type:2
      }
      if (this.cityold !== "") {
        json.city = this.cityold
      }
      if(this.jiage!==""){
        json.jiage = this.jiage
      }
      if(this.tiaojian!==""){
        json.tiaojian = this.tiaojian
      }
      if(this.biaoqian!==""){
        json.biaoqian = this.biaoqian
      }
      if(this.category_id!==''){
        json.categoryId = this.category_id
      }
      if(this.searchvalue !==""){
        json.goodsName = this.searchvalue
      }
      let res = await List(json)
      this.count = res.data.list.total
      for (let i=0;i<res.data.list.data.length;i++){
        this.list.push(res.data.list.data[i])
      }
    },
    async getBannerList(){
      let res = await bannerList()
      if(res.status == 200) {
        //赋值
        this.data = res.data.list;
      }
    },
    async getCity() {
      // let res = await loginAuth({url: location.href});
      let that = this
      // wx.config({
      //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //   appId: res.data.appId, // 必填，公众号的唯一标识
      //   timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      //   nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
      //   signature: res.data.signature,// 必填，签名
      //   jsApiList: ['openLocation', 'getLocation'] // 必填，需要使用的JS接口列表
      // });
      // wx.ready(() => {
        wx.getLocation({
          type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            myBMap.init().then(BMap => {
              let gc = new BMap.Geocoder();
              let pointAdd = new BMap.Point(res.longitude, res.latitude);
              gc.getLocation(pointAdd, function (rs) {
                that.city = rs.addressComponents.city;
                localStorage.setItem('city', that.city)
              })
            })
          },
          cancel: function (res) {
            // console.log("用户取消授权")
            localStorage.setItem('dw', '111')
          }
        });
      // });
    },
    gotoDetials(item) {
      if(item.status ===60){
        Toast('项目已关闭')
        return
      }
      this.$router.push({path: '/pdetails', query: {id: item.goods_id}})
    },
    async onSearch(val) {
      await this.onRefresh()
    },
  },
}
</script>
<style scoped>
.itembegin {
  text-align: left;
  /* border: 1px solid red; */
  height: 40px;
  padding: 10px;
  background-image: url('../assets/images/patient.png');
  background-size: cover;
  background-repeat: no-repeat;
}
.pp{
  margin-left: 10px;

}
.begin {
  width: 100%;
  height: 100%;
}

/deep/ .my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  width: 100%;

}

.health {
  width: 100%;
  height: 100%;
  /* border: 1px solid red; */
}

.van-tag--primary {
  height: 20px;
  background-color: #7ADCBC;
}

.search {
  width: 100%;
}

/deep/ .van-search__content {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  padding-left: 12px;
  background-color: white;
  border-radius: 2px;
  border: 1px solid #57CAC6;
  border-radius: 35px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.van-search__action {
  padding: 0 15px;
  color: #323233;
  font-size: 10px;
  line-height: 34px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: 1px solid #57CAC6;
  border-radius: 35px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  background-color: #57CAC6;
  color: white;
}

.van-search {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  box-sizing: border-box;
  padding: 5px 0;
  background-color: #fff;
}

/deep/ .van-field__left-icon .van-icon, .van-field__right-icon .van-icon {
  display: block;
  font-size: 16px;
  line-height: inherit;
  color: #57CAC6;
}
/deep/ .van-sticky--fixed {
  position: fixed;
  top: 0;
  right: 15px;
  left: 15px;
  z-index: 99;
}
.swipe {
  width: 100%;
  height: 100%;
  margin-top: 5px;
}

.zhineng {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding-top: 10px;
  background-color: white;
}

.beginzhineng {
  height: 30px;
  /*padding: 0 15px;*/
  line-height: 30px;
  color: #101010;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}

.yyicon {
  margin-left: -5px;
  font-size: 14px;

}

.itemcontent {
  position: relative;
  width: 100%;
  border-radius: 4px;
  box-shadow: 1px 1px 25px #eee;
  margin-bottom: 10px;

}

.name {
  font-weight: 600;
  line-height: 20px;
  /* border: 1px solid red; */
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.laber {
  /* border: 1px solid red; */
}

.yaowu {
  margin-top: 10px;
  color: #000;
  font-size: 14px;
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
}

.buchang {
  margin-top: 10px;
  font-weight: 600;
  color: #FF6764;
  text-align: left;
  margin-left: 10px;
  margin-right: 10px;
}

.zhaomu {
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left: 10px;
  margin-right: 10px;

}
.van-button--info {
  color: #fff;
  background-color: #FF6764;
  border: 1px solid #FF6764;
}
.van-divider{
  margin-top: 10px;
  margin-bottom: 0px;
  margin-left: 10px;
  margin-right: 10px;
}

.zhao {
  color: #7ADCBC;
  font-size: 12px;
  font-weight: bold;
}

.baoming {
  margin-top: -5px;
}

.van-button--primary {
  color: #57CAC6;
  background-color: #fff;
  border: 1px solid #57CAC6;
}
.citychange .van-action-sheet__header[data-v-46d6aa14] {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  font-weight: 800;
  font-size: 14px;
  line-height: 48px;
  text-align: left;
  margin-left: 20px;
}
.citychange .quyu {
  text-align: left;
  margin-left: 20px;
  /* border: 1px solid red; */
}

.quyucontent {
  padding: 10px;
  /* border: 1px solid red; */
}

.citycon {
  /* width: calc(100% - 20px); */
  margin-left: 10px;
  height: 100%;
  text-align: left;
  /* border: 1px solid red; */
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}

.cityconpos {
  width: calc(100% - 20px);
  margin-left: 10px;
  height: 100%;
}

.citypos {
  width: 25%;
  /* height: 75px; */
  align-content: center;
  text-align: center;
  /* border: 1px solid red; */
  /* padding-right: 30px; */
}
.citypos1 {
  text-align: center;
  /* border: 1px solid red;   */
}
.citypos2 {
  text-align: center;
  margin-top: 10px;
  /* border: 1px solid red;   */
}
.citycon1 {
  height: 100%;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
/*.citycon1 .van-button--normal {*/
/*  padding: 0 0px;*/
/*  font-size: 14px;*/
/*}*/
.location {
  color: #AAAAAA;
}
/deep/ .van-action-sheet__header{
  -ms-flex-negative: 0;
  flex-shrink: 0;
  font-weight: 800;
  font-size: 14px;
  line-height: 48px;
  text-align: left;
  margin-left: 20px;
}
/deep/ .van-action-sheet__close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 16px;
  color: #4A4A4A;
  font-size: 18px;
  line-height: inherit;
}
.active{
  background-color: #57CAC6;
  color: #fff;
}

.acbutton {
  padding: 0 20px;
  height: 30px;
  line-height: 32px;
  font-size: 12px;
  background-color: #fff;
  color: #57CAC6;
  border: 1px solid #57CAC6;
  border-radius: 30px;
}

.dfbutton {
  padding: 0 20px;
  height: 30px;
  line-height: 32px;
  font-size: 12px;
  background-color: #F7F7F7;
  color: rgba(170, 170, 170, 100);
  border: 1px solid #F7F7F7;
  border-radius: 30px;
}

.dfbutton:active {
  background-color: #fff;
  color: #57CAC6;
  border: 1px solid #57CAC6;
}

.acbutton:active {
  background-color: #fff;
  color: #57CAC6;
  border: 1px solid #57CAC6;
}
.dests{
  background-color: #969799;
  border: 1px solid #969799;
}
</style>



// WEBPACK FOOTER //
// src/views/patient.vue